import HomePage from "../pages/Home/HomePage";
import PurchaseDetails from "../pages/Buy/Details";
import Pay from "../pages/Buy/Pay";
import Result from "../pages/Buy/Result";

import PurchaseDetailsEn from "../pages/Buy/en/Details";
import PayEn from "../pages/Buy/en/Pay";
import ResultEn from "../pages/Buy/en/Result";

const routes = [
  {
    path: "/",
    component: <PurchaseDetails />,
    exact: true,
  },
  {
    path: "/pay",
    component: <Pay />,
    exact: true,
  },
  {
    path: "/result",
    component: <Result />,
    exact: true,
  },
  {
    path: "/en",
    component: <PurchaseDetailsEn />,
    exact: true,
  },
  {
    path: "/en/pay",
    component: <PayEn />,
    exact: true,
  },
  {
    path: "/en/result",
    component: <ResultEn />,
    exact: true,
  },
];

export default routes;
